import baseAPI from "@/api/base";
import { EDIT_PRODUCT_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

interface EditProduct {
  id: string;
  name: string;
  price: number;
  quantity: number;
  tax?: number;
  purchaseType: string;
  opportunityId?: string;
}

interface RegisterProduct {
  name: string;
  price: number;
  quantity: number;
  tax?: number;
  purchaseType: string;
  opportunityId: string;
  organizationId: string;
}

class Product {
  static registerProduct = async (registerProduct: RegisterProduct): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(EDIT_PRODUCT_URL, {
      ...registerProduct,
    });
    return response;
  };

  static editProduct = async (editProduct: EditProduct): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_PRODUCT_URL, {
      ...editProduct,
    });
    return response;
  };
}

export default Product;
